<script lang="ts" setup>
withDefaults(
  defineProps<{
    calculatedLoad: string
    id: string
    badgeLabel: string
    iconClass?: string
  }>(),
  {
    iconClass: () => 'ic-ground'
  }
)
</script>

<template>
  <span :id="id" :class="{ 'is--disabled': !calculatedLoad }" class="badge is--primary">
    <i :class="iconClass" class="badge__icon" />
    <div class="badge__content">
      <div>{{ badgeLabel }}</div>
      <div v-if="calculatedLoad" class="badge__caption" data-hj-whitelist>= {{ calculatedLoad }} kW</div>
      <div v-else>
        <span class="small-text">
          {{ $t('step_heating_details.badge_calculated_load_incomplete_info') }}
        </span>
      </div>
    </div>
  </span>
</template>

<style lang="scss" scoped>
.badge {
  bottom: rem-calc(32);
}
</style>
